import React from "react";
import Card from "components/ui/Card/Card";
import styles from "./ComingSoonPage.module.scss";

type Props = {
  title: string;
  description?: string;
};

function ComingSoonPage({
  title,
  description = "This section is under construction. Check back soon for updated insights.",
}: Props) {
  return (
    <div className={styles.wrapper}>
      <Card>
        <div className={styles.title}>{title}</div>
        <p className={styles.description}>{description}</p>
      </Card>
    </div>
  );
}

export default ComingSoonPage;
